var render, staticRenderFns
import script from "./visitAndSalesStatitics.vue?vue&type=script&lang=js"
export * from "./visitAndSalesStatitics.vue?vue&type=script&lang=js"
import style0 from "./visitAndSalesStatitics.vue?vue&type=style&index=0&id=f978bdfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f978bdfa",
  null
  
)

export default component.exports